import * as React from 'react';
import { st, classes } from './CoreRadioButton.st.css';
import { filterDataProps } from '../../utils/FilterDataProps';
import { dataHooks } from './constants';
import { generateDataAttr } from '../../utils/generateDataAttr';
import { inputMethod } from '../../common/Focusable/utils/inputMethod';
const noop = () => null;
export const ReactFragmentOrDiv = ({ isDiv, children, ...rest }) => isDiv ? (React.createElement("div", { ...rest }, children)) : (React.createElement(React.Fragment, null, children));
export class CoreRadioButton extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            focused: false,
            focusVisible: false,
        };
        this.handleClick = (event) => {
            this.handleInputChange(event);
        };
        this.handleInputChange = (event) => {
            if (!this.props.disabled) {
                this.props.onChange({ value: this.props.value, ...event });
                if (this.radioRef) {
                    this.radioRef.focus();
                }
            }
        };
        this.onHover = (event) => {
            this.props.onHover({ value: this.props.value, ...event });
        };
        this.onFocus = (event) => {
            const isKeyboardFocus = inputMethod.isKeyboard();
            const shouldTriggerFocusByKeyboard = this.props.onFocusByKeyboard && isKeyboardFocus;
            if (shouldTriggerFocusByKeyboard) {
                this.props.onFocusByKeyboard(event);
            }
            this.setState({
                focused: true,
                focusVisible: isKeyboardFocus,
            });
            this.props.onFocus && this.props.onFocus(event);
        };
        this.onInputBlur = (event) => {
            this.setState({ focused: false, focusVisible: false });
            this.props.onBlur && this.props.onBlur(event);
        };
        this.handleInputKeyDown = (event) => {
            this.setState({ focusVisible: true });
            if (!this.props.disabled) {
                this.props.onKeyDown({ value: this.props.value, ...event });
            }
        };
        this.radioRef = undefined;
    }
    focus(options) {
        this.radioRef?.focus(options);
    }
    blur() {
        this.radioRef?.blur();
    }
    render() {
        const { value, name, id, checkedIcon, uncheckedIcon, label, checked, disabled, required, onIconBlur, tabIndex, className, style, unstableHasInnerWrapper = true, } = this.props;
        const focused = this.state.focused;
        return (React.createElement("div", { className: st(classes.root, {
                checked,
                disabled,
                focused,
                'focus-visible': this.state.focusVisible,
                hasInnerWrapper: unstableHasInnerWrapper,
            }, className), ...generateDataAttr(this.props, ['checked', 'disabled', 'required']), "data-focused": focused, "data-focus-visible": this.state.focusVisible, style: style, onChange: this.handleInputChange, onClick: this.handleClick, ...filterDataProps(this.props) },
            React.createElement(ReactFragmentOrDiv, { isDiv: unstableHasInnerWrapper, className: st(classes.innerWrapper) },
                React.createElement("input", { type: "radio", className: classes.hiddenRadio, "data-hook": dataHooks.hiddenRadio, disabled: disabled, required: required, onFocus: this.onFocus, onBlur: this.onInputBlur, checked: checked, value: value, name: name, id: id, tabIndex: tabIndex, onChange: () => null, onKeyDown: this.handleInputKeyDown, ref: (radio) => (this.radioRef = radio), "aria-label": this.props['aria-label'], "aria-describedby": this.props['aria-describedby'], "aria-labelledby": this.props['aria-labelledby'], "aria-checked": checked ? checked : false, autoFocus: this.props.autoFocus }),
                React.createElement("span", { className: classes.icon, "data-hook": dataHooks.icon, onMouseEnter: this.onHover, onMouseLeave: onIconBlur }, checked ? checkedIcon : uncheckedIcon),
                label && (React.createElement("span", { className: classes.label, "data-hook": dataHooks.label }, label)))));
    }
}
CoreRadioButton.displayName = 'RadioButton';
CoreRadioButton.defaultProps = {
    onChange: noop,
    onKeyDown: noop,
    onHover: noop,
    onBlur: noop,
};
//# sourceMappingURL=CoreRadioButton.js.map